// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconStar = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M11.698 5.702L9.814 9.52l-.753.547-4.214.613 3.049 2.972.288.885-.72 4.197 3.769-1.982h.93l3.77 1.982-.72-4.197.287-.885 3.05-2.972-4.215-.613-.753-.547zM10.801 3h1.794l2.548 5.164 5.699.828.554 1.705-4.123 4.02.973 5.675-1.451 1.055-5.097-2.68-5.097 2.68-1.45-1.055.973-5.675L2 10.697l.554-1.705 5.699-.828z"
    />
  );
export default SvgIconStar;
